import React from 'react';
import Promo from './Promo';

const LearningGuidePromo = props => <Promo header="Learning guide" linkText="Get the guide" {...props} />;
export default LearningGuidePromo;
